import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { createAction } from '@mews/framework';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { currentThread } from '../selectors/threads';
import MessagesPanelComponent, {
    MessagesPanelDispatchProps,
    MessagesPanelStateProps,
} from '../components/MessagesPanelComponent';
import { isEditingSubject, currentThreadMessages, areCurrentMessagesLoading, threadSubjectDraft } from '../selectors';
import { closeCurrentThread, enterSubjectEditMode, closeSubjectEditMode, saveThreadSubject } from '../actions/threads';
import { MEMBERS_VISIBILITY_UPDATED } from '../actionTypes';
import { resendMessage } from '../actions/resendMessage';

export default connect<MessagesPanelStateProps, MessagesPanelDispatchProps, {}, ApplicationState>(
    createStructuredSelector({
        messages: currentThreadMessages,
        thread: currentThread,
        subjectDraft: threadSubjectDraft,
        isEditMode: isEditingSubject,
        isLoading: areCurrentMessagesLoading,
    }),

    (dispatch: CommanderThunkDispatch) => ({
        onCloseThread: () => dispatch(closeCurrentThread()),
        onOpenMembers: () => dispatch(createAction(MEMBERS_VISIBILITY_UPDATED, true)),
        onEditClicked: () => dispatch(enterSubjectEditMode()),
        onEditStopped: () => dispatch(closeSubjectEditMode()),
        onMessageResend: (thread: $TSFixMe, message: $TSFixMe) => dispatch(resendMessage(thread, message)),
        onSave: (threadId: $TSFixMe) => dispatch(saveThreadSubject(threadId)),
    })
)(MessagesPanelComponent);
